import FetchFactory from "vuex-fetch-factory";
import { StateInterface } from "./state";
import {
  OrganisationRaw,
  OrganisationModel
} from "modules/relationprofile/models";
import {
  getOrganisationForCurrentUser,
  getPrivatePersonForCurrentUser,
  getFileEntries
} from "modules/relationprofile/api";
import { PrivatePersonModel, PrivatePersonRaw } from "../models/privatePerson";
import { FileEntryRaw, FileEntryModel } from "../models/fileEntry";

const factory = new FetchFactory<StateInterface, {}>();

export default {
  fetchCurrentOrganisation: factory.createSingleFetcher<
    {},
    OrganisationRaw,
    OrganisationModel
  >(
    true,
    "setCurrentOrganisation",
    getOrganisationForCurrentUser,
    (): OrganisationModel => new OrganisationModel()
  ),
  fetchCurrentPrivatePerson: factory.createSingleFetcher<
    {},
    PrivatePersonRaw,
    PrivatePersonModel
  >(
    true,
    "setCurrentPrivatePerson",
    getPrivatePersonForCurrentUser,
    (): PrivatePersonModel => new PrivatePersonModel()
  ),
  fetchFileEntries: factory.createBulkFetcher<
    number,
    FileEntryRaw,
    FileEntryModel
  >(
    true,
    "setFileEntriesForProject",
    getFileEntries,
    (): FileEntryModel => new FileEntryModel()
  )
};
